/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum DiagnosisViewerAliases {
  ACTION_INACTIVATE_DIAGNOSIS = 'action-inactivate-diagnosis',
  ACTION_NEW_DIAGNOSIS = 'action-new-diagnosis',
  CONTEXTUAL_BAR_DIAGNOSIS = 'contextual-bar-diagnosis',
  FIELD_0 = 'field-0',
  FIELD_2 = 'field-2',
  FIELD_4 = 'field-4',
  FIELD_CLASSIFICATION = 'field-classification',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_DISEASE = 'field-disease',
  FIELD_SIDE = 'field-side',
  FIELD_TEXT_ENCOUNTER_NUMBER = 'field-text-encounter-number',
  FORM_DIAGNOSIS_VIEWER = 'form-diagnosis-viewer',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_1 = 'input-1',
  LAYOUT_DIAGNOSIS_CONTENT = 'layout-diagnosis-content',
  LAYOUT_DIAGNOSIS_VIEWER = 'layout-diagnosis-viewer',
  PANEL_FORM = 'panel-form',
  PANEL_MENU_FRAGMENT = 'panel-menu-fragment',
  TEXT_1 = 'text-1',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_7 = 'text-7',
  TEXT_8 = 'text-8',
  TEXT_DETAIL_VALUE = 'text-detail__value',
}
export { DiagnosisViewerAliases };
